// eslint-disable-next-line no-shadow
export enum BadgeType {
  TRIPS = 'TRIPS',
}
